import React, { Suspense, lazy } from 'react';
import { SideSheet, Typography, Spin } from '@douyinfe/semi-ui';
import { IconPriceTag } from '@douyinfe/semi-icons';
import useToolboxStore, { ToolType, AVAILABLE_TOOLS } from './store';
import './index.scss';

const { Title } = Typography;

// 懒加载工具组件
const PricingCalculator = lazy(() => import('./tools/PricingCalculator'));

// 工具组件映射
const ToolComponents: Record<ToolType, React.LazyExoticComponent<React.FC>> = {
  pricing: PricingCalculator,
  more: PricingCalculator, // 占位，后续扩展
};

// 工具图标映射
const ToolIcons: Record<ToolType, React.ReactNode> = {
  pricing: <IconPriceTag />,
  more: <IconPriceTag />,
};

const ToolboxPanel: React.FC = () => {
  const { isOpen, closeToolbox, activeTool } = useToolboxStore();

  // 获取当前工具信息，如果 activeTool 无效则回退到默认工具
  const validActiveTool = ToolComponents[activeTool] ? activeTool : 'pricing';
  const currentTool = AVAILABLE_TOOLS.find((t) => t.key === validActiveTool);
  const ToolComponent = ToolComponents[validActiveTool];

  return (
    <SideSheet
      visible={isOpen}
      onCancel={closeToolbox}
      placement='right'
      width={420}
      mask={false}
      className='toolbox-sidesheet'
      headerStyle={{ borderBottom: '1px solid var(--semi-color-border)' }}
      bodyStyle={{ padding: 0 }}
      title={
        <div className='toolbox-header'>
          {ToolIcons[validActiveTool]}
          <Title heading={5} style={{ margin: 0 }}>
            {currentTool?.label || '智能工具箱'}
          </Title>
        </div>
      }
    >
      <div className='toolbox-content'>
        <Suspense
          fallback={
            <div className='toolbox-loading'>
              <Spin size='large' />
            </div>
          }
        >
          <ToolComponent />
        </Suspense>
      </div>
    </SideSheet>
  );
};

export default ToolboxPanel;
